module.exports = __webpack_public_path__ + "static/homme-femme-8806700cb122384f562a8cad7810def8.svg";